import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        fontFamily: "'Noto Sans JP'",
      },
      "html, body, #root": {
        height: "100%",
        margin: 0,
        overflow: "hidden",
      },
    },
  },
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
});
